import React from 'react';
import {formatAmount} from '../../../utils/Utils';
import {CardProps} from '@material-ui/core/Card';
import {CardHeaderProps} from '@material-ui/core/CardHeader';
import {Card, CardHeader} from './StatisticBox.styles';
import {Skeleton} from '@material-ui/lab';
import PercentBar from './PercentBar';

export interface StatisticBoxProps extends CardProps {
    className?: string;
    type?: 'number' | 'currency' | 'percent' | 'text';
    header: React.ReactNode;
    subHeader?: React.ReactNode;
    CardHeaderProps?: CardHeaderProps;
    isRendering?: boolean;
}

const StatisticBox: React.FC<StatisticBoxProps> = ({
    isRendering = false,
    children,
    className,
    type = 'text',
    header,
    subHeader,
    CardHeaderProps,
    ...CardProps
}) => {
    const title = React.useMemo(() => {
        if (typeof header === 'number' || typeof header === 'string') {
            return formatAmount(type, header);
        }
        return header;
    }, [header, isRendering]);

    return (
        <Card className={className} type={type} {...CardProps}>
            {isRendering ? (
                <Skeleton variant="rect" height={83} style={{borderRadius: 4}} />
            ) : (
                <>
                    {type === 'percent' && (
                        <PercentBar BoxProps={{position: 'absolute'}} value={Number(header)} />
                    )}
                    <CardHeader
                        title={title}
                        titleTypographyProps={{
                            variant: 'h3'
                        }}
                        subheader={subHeader}
                        subheaderTypographyProps={{
                            variant: 'overline'
                        }}
                        {...CardHeaderProps}
                    />
                    {children}
                </>
            )}
        </Card>
    );
};

export default StatisticBox;
